var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Smiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "30px",
    height: "30px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.53333,8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,3c-6.61557,0 -12,5.38443 -12,12c0,6.61557 5.38443,12 12,12c6.61557,0 12,-5.38443 12,-12c0,-6.61557 -5.38443,-12 -12,-12zM15,5c5.53469,0 10,4.46531 10,10c0,5.53469 -4.46531,10 -10,10c-5.53469,0 -10,-4.46531 -10,-10c0,-5.53469 4.46531,-10 10,-10zM10.5,13c-0.82843,0 -1.5,0.67157 -1.5,1.5c0,0.82843 0.67157,1.5 1.5,1.5c0.82843,0 1.5,-0.67157 1.5,-1.5c0,-0.82843 -0.67157,-1.5 -1.5,-1.5zM19.5,13c-0.82843,0 -1.5,0.67157 -1.5,1.5c0,0.82843 0.67157,1.5 1.5,1.5c0.82843,0 1.5,-0.67157 1.5,-1.5c0,-0.82843 -0.67157,-1.5 -1.5,-1.5zM11.99414,18.99219c-0.42506,0.02385 -0.78843,0.31419 -0.90551,0.72351c-0.11707,0.40932 0.03781,0.84789 0.38598,1.0929c0.80431,0.58452 2.00872,1.19141 3.52539,1.19141c1.51667,0 2.72155,-0.60637 3.52539,-1.19141c0.28901,-0.21034 0.44382,-0.5589 0.40609,-0.91435c-0.03773,-0.35545 -0.26225,-0.66375 -0.58897,-0.80874c-0.32672,-0.14498 -0.70598,-0.10461 -0.99485,0.1059c-0.57016,0.41496 -1.36432,0.80859 -2.34766,0.80859c-0.98333,0 -1.77792,-0.39312 -2.34961,-0.80859c-0.16123,-0.12099 -0.35526,-0.19043 -0.55664,-0.19922c-0.03318,-0.00165 -0.06643,-0.00165 -0.09961,0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Smiley);
export default __webpack_public_path__ + "static/media/icons8-smiley.0de08aee592853e37592e4991e0aca28.svg";
export { ForwardRef as ReactComponent };